import React, { useState } from 'react';
import styles from './Videos.module.css';
import { videoData } from './VideosData';

const VideoSection = ({ lang }) => {
  const data = videoData[lang];
  const [activeVideo, setActiveVideo] = useState(data.list[0]);

  return (
    <section className={styles.videoSection}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <h2 className={styles.sectionHeader}>{data.title}</h2>
        
        <div className={styles.videoWrapper}>
          <div className={styles.mainVideo}>
            {/* Ab sirf local video player hai */}
            <video controls width="100%" height="100%" key={activeVideo.src}>
              <source src={activeVideo.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className={styles.playlist}>
            {data.list.map((video) => (
              <div 
                key={video.id} 
                className={`${styles.videoItem} ${activeVideo.id === video.id ? styles.active : ''}`} 
                onClick={() => setActiveVideo(video)}
              >
                <img src={video.thumb} className={styles.thumb} alt={video.title} />
                <h4>{video.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;